import PageManager from './page-manager';

export default class Subscribe extends PageManager {}



// WEBPACK FOOTER //
// ./assets/js/theme/subscribe.js